import { render, staticRenderFns } from "./QuickAccessEdit.vue?vue&type=template&id=5a5641d5&scoped=true&"
import script from "./QuickAccessEdit.vue?vue&type=script&lang=js&"
export * from "./QuickAccessEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5641d5",
  null
  
)

export default component.exports